<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="roles"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Roles</v-toolbar-title>
                        <v-divider
                            class="mx-4"
                            inset
                            vertical
                        ></v-divider>                    
                        <v-spacer></v-spacer>
                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                        <v-spacer></v-spacer>                 
                    </v-toolbar>
                </template>
               
                
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.issueID">
                                                
                            <td class="text-xs-right">{{item.rol}} </td>
                             <td class="text-xs-right">{{item.customer}} </td>
                            <td class="text-xs-right">{{item.description}} </td>                                                    
                                     
                            <td class="text-xs-right">
                                <div v-if="item.condition=='1'">
                                    <span class="blue--text">Enable</span>
                                </div>
                                <div v-else="item.condition=='false'">
                                    Disable 
                                </div>
                            </td>
                           
                            

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
   
    import axios from 'axios';   
   
    export default{
        components: {                      
        },
       
        data (){
            return {
                  roles:[],                  
                  dialog: false,
                  dialogLoading: false,
                    headers: [                       
                        { text: 'Rol', value: 'rol', sortable: false },
                        { text: 'Customer', value: 'customer', sortable: false },
                        { text: 'Description', value: 'description', sortable: false },
                        { text: 'Estado', value: 'condition', sortable: false }                                               
                    ],
                    //moment: moment, // Set to whatever
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                    editedItem: {
                        name: '',
                        calories: 0,
                        fat: 0,
                        carbs: 0,
                        protein: 0,
                    },
                     
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Issue' : 'Edit Issue'
            },            
        },

        watch: {              
        },

        created () {           
            this.list();                    
        },

         methods: {          
            list(){
                let me=this;
                axios.get('api/Rols/List').then(function(response){                   
                    me.roles = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },           
        },

    }
</script>